import { render, staticRenderFns } from "./TravelPolicyForm.vue?vue&type=template&id=2901e772"
import script from "./TravelPolicyForm.vue?vue&type=script&lang=js"
export * from "./TravelPolicyForm.vue?vue&type=script&lang=js"
import style0 from "./TravelPolicyForm.vue?vue&type=style&index=0&id=2901e772&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports